import $ from 'jquery';

class ImageLink {
  constructor(element) {
    this.$element = $(element);
    this.attachAttributes();
  }

  attachAttributes() {
    this.$element.attr({
      href: this.src,
      rel: 'lightbox',
    });
  }

  get src() {
    const src = this.$element.find('img').attr('src');
    return src.replace(/\/sites\/(main|default)\/files(\/imagecache\/[^/]+)\/main-images\//, '/sites/$1/files/imagecache/lightbox/main-images/');
  }
}

export default class Overview {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.setLinkDestination();
    this.attachBehaviors();
  }

  setLinkDestination() {
    this.$imageLinks.each((i, element) => {
      if (!element.ImageLink) {
        element.ImageLink = new ImageLink(element);
      }
    });
  }

  attachBehaviors() {
    if (window.Lightbox) {
      window.Lightbox.initList(this.element);
    }
  }

  get $imageLinks() {
    return this.$element.find('.field-image:not(.field-video) a');
  }
}
